import React, { useEffect, useState } from "react";
import * as L from "leaflet";

import { Marker, Popup } from "react-leaflet";
import { clusterIcon } from "./utils";

interface ILMarker {
	onClick?: () => boolean;
	children?: JSX.Element | false;
	popupClass?: string;
	position: L.LatLngExpression;
	icon?: L.DivIcon;
	count?: number;
	isHighlight?: boolean;
}

export const LMarker = (props: ILMarker): JSX.Element => {
	const [markerRef, setMarkerRef] = useState<L.Marker | null>(null);
	const [isClicked, setIsClicked] = useState<boolean>(false);

	useEffect(() => {
		if (props.isHighlight && props.children && !isClicked) {
			setIsClicked(true);
		} else if (isClicked) {
			setIsClicked(false);
		}
	}, [isClicked, props.children, props.isHighlight]);

	useEffect(() => {
		const marker = markerRef ? markerRef["leafletElement"] : undefined;
		if (marker) {
			if (isClicked) {
				marker.openPopup();
				const closeButtons = document.getElementsByClassName("leaflet-popup-close-button");
				if (closeButtons && closeButtons.length > 0) {
					L.DomEvent.on(closeButtons[0] as HTMLElement, "click", ev => {
						ev.preventDefault(); // 3. stop it here
					});
				}
			} else {
				marker.closePopup();
			}
		}
	}, [markerRef, isClicked]);

	const onClickHandler = (event: any) => {
		event.preventDefault && event.preventDefault();

		if (props.onClick) {
			event.target.closePopup();
			if (!props.onClick()) {
				return;
			}
		}

		setIsClicked(!isClicked);
	};

	const onMouseEnterHandler = (event: any) => {
		event.preventDefault && event.preventDefault();
		if (!isClicked && props.children && !props.count) {
			event.target.openPopup();
			const closeButtons = document.getElementsByClassName("leaflet-popup-close-button");
			// 2. add the event handler - if you have more than one, loop here
			if (closeButtons && closeButtons.length > 0) {
				L.DomEvent.on(closeButtons[0] as HTMLElement, "click", ev => {
					ev.preventDefault(); // 3. stop it here
				});
			}
		}
	};

	const onMouseLeaveHandler = (event: any) => {
		event.preventDefault && event.preventDefault();
		if (!isClicked && props.children && !props.count) {
			event.target.closePopup();
		}
	};

	const onPopupCloseHandler = () => {
		setIsClicked(false);
	};

	const onRightClickHandler = (event: any) => {
		event.preventDefault && event.preventDefault();

		if (!isClicked && props.children) {
			event.target.openPopup();
			const closeButtons = document.getElementsByClassName("leaflet-popup-close-button");
			// 2. add the event handler - if you have more than one, loop here
			if (closeButtons && closeButtons.length > 0) {
				L.DomEvent.on(closeButtons[0] as HTMLElement, "click", ev => {
					ev.preventDefault(); // 3. stop it here
				});
			}
		} else {
			event.target.closePopup();
		}

		setIsClicked(!isClicked);
	};

	return (
		<Marker ref={setMarkerRef}
			position={props.position}
			icon={props.icon || clusterIcon(props.count, props.isHighlight)}
			eventHandlers={{
				click: onClickHandler,
				mouseover: onMouseEnterHandler,
				mouseout: onMouseLeaveHandler,
				contextmenu: onRightClickHandler,
				popupclose: onPopupCloseHandler,
			}}>
			{props.children && (
				<Popup className={props.popupClass} closeOnClick={false} autoClose={false}>
					{props.children}
				</Popup>
			)}
		</Marker>
	);
};
